export default __webpack_public_path__ + "static/media/img5.c5066366.jpg";